import { gzipSync, strToU8 } from 'fflate'

/*
 * Converts data to the base64url format expected by the _criteria query parameter.
 */
export const encodeCriteriaForQuery = (criteria: unknown): string => {
  const compressedCriteria = gzipSync(strToU8(JSON.stringify(criteria)))
  let binary = ''

  for (const byte of compressedCriteria) {
    binary += String.fromCodePoint(byte)
  }

  let encodedCriteria = btoa(binary).replaceAll('+', '-').replaceAll('/', '_')

  while (encodedCriteria.endsWith('=')) {
    encodedCriteria = encodedCriteria.slice(0, -1)
  }

  return encodedCriteria
}
